/* Punisher Vault polish scripts. Added 2026-07-02, extended 2026-07-03.
   Revert: delete this file and its script tag in layout/theme.liquid. */
(function () {
  /* Product cards crop images to the card frame (object-fit cover), which
     looks right for portrait and square photos but clips the sides of wide
     ones. Detect wide images and let those show in full instead.
     2026-07-17: collection-list cards are excluded. They get a fixed 3:2
     landscape frame with cover in pv-polish.css (checklist #47), so the
     wide-image guard must not force them back to contain. */
  function fit(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    if (img.closest('.collection-list')) return;
    if (img.naturalWidth / img.naturalHeight > 1.25) {
      img.style.objectFit = 'contain';
    }
  }
  function scan() {
    document.querySelectorAll('.card--standard .card__inner .card__media img').forEach(fit);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  /* Lazy loaded images arrive late, and some installed apps interfere with
     events on this store, so poll instead of trusting load events. One
     cheap pass every half second for 45 seconds, then stop. */
  var runs = 0;
  var timer = setInterval(function () {
    scan();
    runs += 1;
    if (runs > 90) clearInterval(timer);
  }, 500);
})();
